import React, {useEffect, useState, useRef} from 'react';
import '../App.css';
import { Alert } from 'react-bootstrap';
import Axios from 'axios';
import Bodyheaderloged from './bodyheaderloged'
import { PDFReader } from 'reactjs-pdf-reader'

function Bodygestionminutas (props){
    const fileInputRef = useRef();
    const [file, setFile] = useState('')
    const [fileName, setFileName] = useState("")
    const [urlminuta, setUrlMinuta] = useState("")
    const [tituloAlert, setTituloAlert] = useState('')
    const [textoAlert, setTextoAlert] = useState('')
    const [claseAlert, setClaseAlert] = useState('')    
    const [alert, setAlert] = useState(false);

    const saveFile = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    }

    const uploadFile = async (e) => {

        if(file != '')
        {
            let casino_id = window.localStorage.getItem('MY_APP_STATE_PROF_CASINO_ID').replace('"', '')
            const formData = new FormData();
            formData.append("file", file);
            formData.append("fileName", fileName);
            formData.append("casino_id", casino_id.replace('"', ''));
            formData.append("tipo_archivo", 1);
            try {
                const res = await Axios.post(
                    process.env.REACT_APP_URLUPLOADFILE,
                    formData
                )
                
                if(res.data.MessageCode == "0")
                {   
                    fileInputRef.current.value = null
                    setFile('')  
                    setUrlMinuta(res.data.UrlFile)
                    setTituloAlert('Carga de archivo')
                    setTextoAlert('Archivo Cargado Correctamente')
                    setClaseAlert('success')
                    setAlert(true)
                    setTimeout(() => {    
                        setAlert(false)
                    }, 3000)
                }
                else
                {
                    fileInputRef.current.value = null  
                }
            } catch (ex) {
                console.log(ex);
            }
        }
        else
        {
            setTituloAlert('Carga de archivo')
            setTextoAlert('Debe seleccionar un archivo')
            setClaseAlert('warning')
            setAlert(true)
            setTimeout(() => {    
                setAlert(false)
            }, 3000)
        }
    }    
    
    
    useEffect(() => {

    }, [urlminuta]);

    return (

        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>

            <div className='flex justify-start w-full'>
                <div className='w-full'>

                    {alert
                    ?<Alert variant={claseAlert} onClose={() => setAlert(false)} dismissible fade show>
                    <Alert.Heading>{tituloAlert}</Alert.Heading>
                    <p>
                        {textoAlert}
                    </p>
                    </Alert>
                    :''
                    }

                    {/* Zona 1 - Seleccion de archivo */}
                    <div className="bg-white shadow-lg p-6 mx-4 mb-2">
                        <h2 className="text-xl font-semibold mb-4">Filtros de Reporte Compra Tickets</h2>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">

                            {/* Campo file upload */}
                            <div className="flex flex-col">
                                <label htmlFor="fileUpload" className="text-sm font-medium text-gray-600 mb-1">Seleccionar Archivo</label>
                                <input 
                                    type='file' 
                                    onChange={saveFile} 
                                    ref={fileInputRef}
                                    className="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2"    
                                />
                            </div>

                            {/* Campo Fecha Fin */}
                            <div className="flex flex-col">
                                <label htmlFor="nothin" className="text-sm font-medium text-gray-600 mb-1">Subir Archivo</label>
                                
                                <button  onClick={uploadFile} className="w-full bg-indigo-600 text-white p-2 text-sm rounded-lg shadow-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 flex items-center justify-center space-x-2">
                                    {/* Icono de Reporte */}
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-5 w-5 mr-2">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h2M15 3h-6a2 2 0 0 0-2 2v4h10V5a2 2 0 0 0-2-2z" />
                                    </svg>
                                    {/* Texto del Botón */}
                                    Subir Minuta
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white shadow-lg p-6 mx-4 mb-2">
                        <object width="100%" height="800" data={urlminuta} type="application/pdf">
                            {" "}
                        </object>
                    </div>

                    <div className="bg-white shadow-lg p-6 mx-4 mb-2">
                        <div className='row'>
                            <div className='col col-lg-12'>
                                
                            </div>
                        </div>
                    </div>
 
                </div>   
                 
            </div>
        </div>
         
    )
}
export default Bodygestionminutas